import {
  BankAccount,
  BankAccountFormData,
  BankAccountFilters,
  BankAccountListResponse,
} from '../types/bank-account.types'

class BankAccountService {
  private baseUrl = '/api/bank-accounts'

  async getBankAccounts(
    filters: BankAccountFilters,
  ): Promise<BankAccountListResponse> {
    // Mock implementation
    const mockAccounts: BankAccount[] = [
      {
        id: '1',
        bankName: 'Premier Bank',
        branch: 'Hargeisa Main Branch',
        type: 'Current' as any,
        accountNo: '1234567890',
        address: '123 Banking Street, Hargeisa',
        alias: 'Premier-Hargeisa-Current',
        status: 'Active' as any,
        createdBy: 'Admin',
        createdAt: '2024-01-15T10:00:00Z',
        updatedAt: '2024-01-15T10:00:00Z',
      },
      {
        id: '2',
        bankName: 'Dahabshiil Bank',
        branch: 'Mogadishu Branch',
        type: 'Savings' as any,
        accountNo: '9876543210',
        address: '456 Finance Road, Mogadishu',
        alias: 'Dahabshiil-Mogadishu-Savings',
        status: 'Active' as any,
        createdBy: 'Admin',
        createdAt: '2024-01-16T11:00:00Z',
        updatedAt: '2024-01-16T11:00:00Z',
      },
    ]

    return {
      data: mockAccounts,
      total: mockAccounts.length,
      page: filters.page || 1,
      limit: filters.limit || 20,
    }
  }

  async getBankAccountById(id: string): Promise<BankAccount> {
    const response = await this.getBankAccounts({})
    const account = response.data.find((a) => a.id === id)
    if (!account) throw new Error('Bank account not found')
    return account
  }

  async createBankAccount(data: BankAccountFormData): Promise<BankAccount> {
    console.log('Creating bank account:', data)
    return {
      id: Date.now().toString(),
      ...data,
      createdBy: 'Current User',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }
  }

  async updateBankAccount(
    id: string,
    data: Partial<BankAccountFormData>,
  ): Promise<BankAccount> {
    console.log('Updating bank account:', id, data)
    const account = await this.getBankAccountById(id)
    return {
      ...account,
      ...data,
      updatedAt: new Date().toISOString(),
    } as BankAccount
  }

  async deleteBankAccount(id: string): Promise<void> {
    console.log('Deleting bank account:', id)
  }
}

export const bankAccountService = new BankAccountService()
